<kt-splash-screen *ngIf="loader"></kt-splash-screen>
<router-outlet></router-outlet>
<!--<div *ngIf="loading" class="loading">Loading&#8230;</div>-->
<p-blockUI [blocked]="loading" style="z-index: 1000!important;">
    <p-progressSpinner></p-progressSpinner>
</p-blockUI>
